import * as shopifyThemeImages from '@shopify/theme-images';
const updateUrl = (state) => {
  state.el.src = state.zoomFlag ? shopifyThemeImages.getSizedImageUrl(state.el.dataset.rawSrc, '2000x2000') : shopifyThemeImages.getSizedImageUrl(state.el.dataset.rawSrc, '1000x1000');
  return state;
}
export default updateUrl;